import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CollaborationRequestBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const requestCollaboration = createApiThunk<void, CollaborationRequestBody>(
  "collaborations/requestCollaboration",
  async (collaborationRequest: CollaborationRequestBody, { extra: { teacherRepository } }) => {
    return teacherRepository!.requestCollaboration(collaborationRequest);
  },
);

export const resetRequestCollaboration = createAction("collaborations/resetRequestCollaboration");
